import React from 'react';
import type { SortableTableHeaderProps } from './SortableTableHeader.types';

export const SortableTableHeader = ({ 
    children, 
    sortColumn,
    currentSortKey,
    sortOrder = 'asc',
    onSort,
    className = "text-left",
    showInactiveIcon = false
}: SortableTableHeaderProps) => {
    const sortIcon = sortOrder === "asc" 
        ? "vismaicon vismaicon-sm vismaicon-arrow-up-circle" 
        : "vismaicon vismaicon-sm vismaicon-arrow-down-circle";
    
    const isActive = currentSortKey === sortColumn;
    const isClickable = Boolean(onSort) && Boolean(sortColumn);

    const handleClick = () => {
        if (sortColumn !== undefined) {
            onSort?.(sortColumn);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (sortColumn === undefined) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onSort?.(sortColumn);
        }
    };
    
    return (
        <th className={className}>
            <div 
                className="d-flex justify-content-between align-items-center" 
                onClick={handleClick}
                role={isClickable ? 'button' : undefined}
                tabIndex={isClickable ? 0 : -1}
                onKeyDown={handleKeyDown}
                style={{ cursor: isClickable ? 'pointer' : 'default' }}
            >
                {children}
                {Boolean(sortColumn) && isActive && <i className={sortIcon}></i>}
                {Boolean(sortColumn) && !isActive && showInactiveIcon && (
                    <span style={{ opacity: 0.3 }}>
                        <i className="vismaicon vismaicon-sm vismaicon-arrow-up-circle"></i>
                    </span>
                )}
            </div>
        </th>
    );
};

export default SortableTableHeader;

